import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { GlobalContext, UserContext } from 'components/context'
import { Highlights, AccessInfo, Pin, PinInfo, Workouts } from './components'
import PTPackage from '../PT/PTPackage'
import './slide.css'
import { currentActiveTypeFromKeys } from 'helpers'
import { featureEnabled, featureExcluded } from 'components/features'

const IndexInfo = () => {
  const { membership } = React.useContext(UserContext)
  const [slideUpOrDown, setSlideUpOrDown] = useState('down')
  const { t, locale, env } = React.useContext(GlobalContext)

  const rfid = currentActiveTypeFromKeys(membership?.keys, 'rfid', true)
  const nfc = currentActiveTypeFromKeys(membership?.keys, 'nfc', true)
  const pin = currentActiveTypeFromKeys(membership?.keys, 'pin', true)
  const nfcEnabled = featureEnabled('nfc', locale, env)
  const excluded = featureExcluded('nfc', 'location', membership?.location?.name)

  const slideDown = (ev) => {
    setSlideUpOrDown('down')
  }

  const slideUp = (ev) => {
    setSlideUpOrDown('up')
  }

  const showAccess = () => {
    if (!nfcEnabled || excluded) {
      return (
        <React.Fragment>
          <PinInfo rfid={rfid} />
        </React.Fragment>
      )
    }

    if (nfc || rfid) return null

    if (pin && !rfid) {
      return (
        <React.Fragment>
          <Pin />
          <AccessInfo />
        </React.Fragment>
      )
    }

    return (<AccessInfo />)
  }

  const statsOrDocument = () => {
    let requiresSignature = false

    if (featureEnabled('docSigning', locale, env)) {
      if (membership.documents && membership.documents.length > 0) {
        if (membership.documents.every(d => d.status === 'pending')) {
          requiresSignature = true
        }
      }
    }

    if (requiresSignature) {
      return (
        <div className="document">
          <h3>{t('pages.info.document')}</h3>
          <Link to={'/membership/documents'} className="sign">
            { t('pages.info.document_link') }
          </Link>
        </div>
      )
    }
    return (
      <div>
        <Workouts />
        {showAccess()}
      </div>
    )
  }

  const ptPackage = () => {
    if (!featureEnabled('pts', locale, env)) return null

    return (
      <PTPackage onEnd={slideDown} onStart={slideUp} />
    )
  }

  if (!membership) return null

  return (
    <div id={'index-info'}>
      <div className={slideUpOrDown}>
        {statsOrDocument()}
        <Highlights />
      </div>
      {ptPackage()}
    </div>
  )
}

export default IndexInfo
